<div class="row center-menu">
    <div class="col-12 col-sm-12 col-md-6 col-lg-4 mb-4">
        <h3 style="margin-left: 1em;" class="pb-4">Neprose</h3>
        <p style="margin-left: 1em; line-height: 1.5;">Neprose is an online venture of the company Nepal Property Investment and Development Pvt. Ltd.</p>
        <p style="margin-left: 1em;"><img src="assets\whatsapp.png">&nbsp;&nbsp;WhatsApp - 9852646089</p>
        <p style="margin-left: 1em;"><img src="assets\viber.png">&nbsp;&nbsp;Viber - 9852646089</p>
        <p style="margin-left: 1em;"><img src="assets\call-white.png">&nbsp;&nbsp;023-546089 / 9852646089</p>
        <p style="margin-left: 1em;"><img src="assets\mail-white.png">&nbsp;&nbsp;nepalpropertyservices@gmail.com</p>
    </div>
    <div class="col-12 col-sm-12 col-md-6 col-lg-5 mb-4">
        <h3 class="pl-3 pb-4">Useful Links</h3>
        <ul>
            <li><a href="http://www.nepalstock.com/" target="_blank">Nepal Stock Exchange</a></li>
            <li><a href="https://nlhda.org.np" target="_blank">Nepal Land and Housing Developers' Association</a></li>
            <li><a href="https://www.facebook.com/PDANepal" target="_blank">Property Dealers' Association of Nepal</a></li>
            <li><a href="https://nrb.org.np/" target="_blank">Nepal Rastra Bank</a></li>
            <li><a href="https://mof.gov.np" target="_blank">Ministry Of Finance</a></li>
        </ul>
    </div>
    <div class="col-12 col-sm-12 col-md-6 col-lg-3 mb-4">
        <h3 class="pl-3 pb-4">About Us</h3>
        <ul>
            <li><a routerLink="/about">About</a></li>
            <li><a routerLink="/tos">Terms and Condition</a></li>
            <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
            <li><a routerLink="/property-management">Property Management</a></li>
            <li><a routerLink="/contact">Contact</a></li>
        </ul>
    </div>
</div>
<div class="media-links">
    <a href="https://facebook.com/nepalpropertyservices" target="_blank"><i class="fab fa-facebook-square"></i></a>
    <a href="https://twitter.com/neprose" target="_blank"><i class="fab fa-twitter-square"></i></a>
    <a href="https://linkedin.com/company/nepal-property-services" target="_blank"><i class="fab fa-linkedin"></i></a>
    <a href="https://www.youtube.com/channel/UCfVCNUO53YyBfShsnRxuHRw" target="_blank"><i class="fab fa-youtube-square"></i></a>
</div>
<small class="d-table mx-auto mb-3 powered-by">Powered By: <a href="https://4tuples.com" target="_blank"><strong>Four Tuples Solution</strong></a></small>